export default "__VITE_ASSET__CX5nDX0k__"